import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import RtlOptOut from './RtlOptOut';
import ClientProvider from './client';
export default createDemo(import.meta.url, RtlOptOut, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/right-to-left/demos/rtl-opt-out/RtlOptOut.tsx",
    "fileName": "RtlOptOut.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { prefixer } from 'stylis';\nimport rtlPlugin from '@mui/stylis-plugin-rtl';\nimport { CacheProvider } from '@emotion/react';\nimport createCache from '@emotion/cache';\nimport { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\nconst Normal = styled('div')`\n  text-align: left;\n`;\n\nconst Noflip = styled('div')`\n  /* @noflip */\n  text-align: left;\n`;\n\nconst rtlCache = createCache({\n  key: 'muirtl',\n  stylisPlugins: [prefixer, rtlPlugin],\n});\n\nconst ltrCache = createCache({\n  key: 'mui',\n});\n\nexport default function RtlOptOut() {\n  const [rtl, setRtl] = React.useState(false);\n\n  const handleChange = () => {\n    setRtl(!rtl);\n  };\n\n  return (\n    <Box sx={{ width: '100%', display: 'flex' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FormControlLabel\n        control={<Switch onChange={handleChange} />}\n        label=\"Toggle RTL\"\n      />\n      <CacheProvider value={rtl ? rtlCache : ltrCache}>\n        <Box sx={{ flexGrow: 1, mx: 2 }} dir={rtl ? 'rtl' : undefined}>\n          <Normal>RTL normal behavior</Normal>\n          <Noflip>RTL noflip</Noflip>\n        </Box>\n      </CacheProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 50,
        "focusedLines": 10,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { prefixer } from 'stylis';\nimport rtlPlugin from '@mui/stylis-plugin-rtl';\nimport { CacheProvider } from '@emotion/react';\nimport createCache from '@emotion/cache';\nimport { styled } from '@mui/material/styles';\nimport Box from '@mui/material/Box';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\n\nconst Normal = styled('div')`\n  text-align: left;\n`;\n\nconst Noflip = styled('div')`\n  /* @noflip */\n  text-align: left;\n`;\n\nconst rtlCache = createCache({\n  key: 'muirtl',\n  stylisPlugins: [prefixer, rtlPlugin],\n});\n\nconst ltrCache = createCache({\n  key: 'mui',\n});\n\nexport default function RtlOptOut() {\n  const [rtl, setRtl] = React.useState(false);\n\n  const handleChange = () => {\n    setRtl(!rtl);\n  };\n\n  return (\n    <Box sx={{ width: '100%', display: 'flex' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FormControlLabel\n        control={<Switch onChange={handleChange} />}\n        label=\"Toggle RTL\"\n      />\n      <CacheProvider value={rtl ? rtlCache : ltrCache}>\n        <Box sx={{ flexGrow: 1, mx: 2 }} dir={rtl ? 'rtl' : undefined}>\n          <Normal>RTL normal behavior</Normal>\n          <Noflip>RTL noflip</Noflip>\n        </Box>\n      </CacheProvider>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 38
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FormControlLabel"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 39
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "control"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 40
            },
            [
              "        ",
              [
                "span",
                "pl-e",
                "label"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Toggle RTL",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            "      />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "CacheProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "rtl"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "?"
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "rtlCache"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "ltrCache"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "flexGrow"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "mx"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "dir"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "rtl"
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                "?"
              ],
              " ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "rtl",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-c1 di-n",
                "undefined"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Normal"
              ],
              ">RTL normal behavior</",
              [
                "span",
                "pl-c1 di-jsx",
                "Normal"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Noflip"
              ],
              ">RTL noflip</",
              [
                "span",
                "pl-c1 di-jsx",
                "Noflip"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "Box"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "CacheProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 50,
    "focusedLines": 10,
    "collapsible": true,
    "externals": [
      "react",
      "stylis",
      "@mui/stylis-plugin-rtl",
      "@emotion/react",
      "@emotion/cache",
      "@mui/material/styles",
      "@mui/material/Box",
      "@mui/material/FormControlLabel",
      "@mui/material/Switch"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
